/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetAllegato } from './target-allegato';
import { TipoFileSistema } from './tipo-file-sistema';
import { OrigineAllegato } from './origine-allegato';


export interface PraticaAllegatoDTO { 
    id?: string;
    pratica_id?: string;
    target?: TargetAllegato;
    tipo_pratica_attributo_id?: string;
    chiave_attributo?: string;
    component_label?: string;
    origine?: OrigineAllegato;
    tipo_file_sistema?: TipoFileSistema;
    nome_file_originale?: string;
    content_type?: string;
    size_bytes?: number;
    label?: string;
    note?: string;
    uploaded_by_user_id?: string;
    uploaded_at?: string;
    version?: number;
}



